import { Link } from 'react-router-dom';

import { Icon } from '../components/ui/Icon';
import { ThemeToggle } from '../components/ui/Theme';
import styles from './WelcomePage.module.css';

export function WelcomePage() {
  return (
    <main className={styles.page}>
      <header className={styles.header}>
        <div className={styles.brand}>
          <img alt="WOne" className={styles.brandMark} src="./brand/wone-logo.png" />
          <span>WOne PC Design</span>
        </div>
        <div className={styles.headerActions}>
          <span className={styles.status}>Draft · 0.1.0</span>
          <ThemeToggle />
        </div>
      </header>

      <section className={styles.hero}>
        <p className={styles.eyebrow}>DESIGN AS CODE</p>
        <h1>网页，就是设计稿。</h1>
        <p className={styles.summary}>
          在真实浏览器里查看页面、体验交互、检查样式，并获取设计交付所需的图标与素材。
        </p>
        <div className={styles.actions}>
          <Link className={styles.primaryAction} to="/handoff">
            查看交付说明
            <Icon name="a-arrow-right" size="sm" />
          </Link>
          <Link className={styles.secondaryAction} to="/projects">进入项目页面</Link>
          <span className={styles.canvasNote}>PC 基准画布 1440 × 900</span>
        </div>
      </section>

      <section className={styles.workflow} aria-label="交付流程">
        <article>
          <span>01</span>
          <h2>页面与交互</h2>
          <p>通过链接直接体验当前需求，不依赖设计工具客户端。</p>
        </article>
        <article>
          <span>02</span>
          <h2>F12 检查</h2>
          <p>样式类名与源码保持可读，语义 token 可直接定位。</p>
        </article>
        <article>
          <span>03</span>
          <h2>素材交付</h2>
          <p>在 handoff 页面获取页面状态、图标和下载资源。</p>
        </article>
      </section>
    </main>
  );
}
